import { constants as cons } from '../Constants/constants'

export const getI18nObjValue = (guluLang, i18nObj) => {
    let locale = cons.I18N_OBJ_LANG.EN

    if (guluLang === cons.LANG.TC) {
        locale = cons.I18N_OBJ_LANG.ZH_HK
    }

    if (guluLang === cons.LANG.SC) {
        locale = cons.I18N_OBJ_LANG.ZH_CN
    }

    return i18nObj[locale] || ''
}

export const findLangKey = (guluLang, langObj) => {
    // Define all possible variations for each language
    const LANG_MAP = {
        en: ['en'],
        tc: ['tc', 'zh-HK', 'zh-Hant'],
        sc: ['sc', 'zh-CN', 'zh-SC', 'zh-Hans']
    };

    const possibleKeys = LANG_MAP[guluLang] || [guluLang];

    const targetKey = possibleKeys.find(key => langObj[key]);

    // const langValue = langObj[targetKey] || langObj['en'] || '';

    return targetKey
}